    <div class="main-area">

      <div class="module-header" style="justify-content: flex-start;">
        
        <button class="btn-sidebar-toggle"
                [class.is-collapsed]="isSidebarCollapsed"
                (click)="isSidebarCollapsed = !isSidebarCollapsed; sidebarCollapsedChange.emit(isSidebarCollapsed)"
                [title]="isSidebarCollapsed ? 'Expand Sidebar' : 'Collapse Sidebar'">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="15 18 9 12 15 6"></polyline>
          </svg>
        </button>
        <h3 style="margin-left: 44px;">{{ selected ? (selected.displayName?.trim() || selected.entity) : 'DEAM SERVICE' }}</h3>

        <div class="ent-action-btns" *ngIf="selected">
          <button class="btn-action btn-json" [class.active]="showJsonPanel" (click)="toggleJsonPanel()">
            <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
              <path d="M4 2H2.5A1.5 1.5 0 0 0 1 3.5v6A1.5 1.5 0 0 0 2.5 11H4M9 2h1.5A1.5 1.5 0 0 1 12 3.5v6A1.5 1.5 0 0 1 10.5 11H9" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
              <path d="M5 5l-2 1.5L5 8M8 5l2 1.5L8 8" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            {{ showJsonPanel ? 'Form View' : 'JSON View' }}
          </button>
          <button class="btn-action btn-hierarchy" [class.active]="showHierarchyPanel" (click)="toggleHierarchyPanel()">
            <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
              <circle cx="6.5" cy="2.2" r="1.4" stroke="currentColor" stroke-width="1.2"/>
              <circle cx="2.2" cy="10.8" r="1.4" stroke="currentColor" stroke-width="1.2"/>
              <circle cx="10.8" cy="10.8" r="1.4" stroke="currentColor" stroke-width="1.2"/>
              <path d="M6.5 3.6v2.4M5.3 6.6L2.9 9.6M7.7 6.6l2.4 3" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
            </svg>
            {{ showHierarchyPanel ? 'Form View' : 'Hierarchy View' }}
          </button>
          <button class="btn-action btn-save" (click)="save()" [disabled]="saveStatus === 'saving'">
            <svg *ngIf="saveStatus !== 'saved'" width="13" height="13" viewBox="0 0 13 13" fill="none"><path d="M9.5 1H2.5A1.5 1.5 0 0 0 1 2.5v8A1.5 1.5 0 0 0 2.5 12h8A1.5 1.5 0 0 0 12 10.5V3.5L9.5 1z" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/><path d="M3.5 1v3h6V1" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/></svg>
            <svg *ngIf="saveStatus === 'saved'" width="13" height="13" viewBox="0 0 13 13" fill="none"><path d="M2 6.5l3 3 6-6.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>
            {{ saveStatus === 'saving' ? 'Saving…' : saveStatus === 'saved' ? 'Saved' : 'Save' }}
          </button>
          <button class="btn-action btn-del" (click)="deleteEntity(selected.id)">
            <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><path d="M2 4h9M5 4V2.5h3V4M4 4l.5 6.5h4L9 4" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>
            Delete
          </button>
        </div>
      </div>

      <ng-container *ngIf="selected; else emptyState">

        <!-- JSON View -->
        <div class="json-panel" *ngIf="showJsonPanel">
          <div class="json-panel-hdr">
            <span>DEAM JSON — {{ selected.entity }}</span>
            <button class="btn-copy-json" (click)="copyJson()">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><rect x="1" y="4" width="6" height="7" rx="1" stroke="currentColor" stroke-width="1.2"/><path d="M4 4V2.5A1.5 1.5 0 0 1 5.5 1H9.5A1.5 1.5 0 0 1 11 2.5V6.5A1.5 1.5 0 0 1 9.5 8H8" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg>
              Copy JSON
            </button>
          </div>
          <pre class="json-body">{{ selectedJson }}</pre>
        </div>

        <!-- Hierarchy View -->
        <div class="hierarchy-panel" *ngIf="showHierarchyPanel">
          <div class="hierarchy-panel-hdr">
            <span>Entity Relationships — {{ selected.entity }}</span>
            <div class="hierarchy-banner-inline" [class.warn]="hierarchyHasCircular">
              <svg *ngIf="hierarchyHasCircular" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
              <svg *ngIf="!hierarchyHasCircular" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>
              <span *ngIf="hierarchyHasCircular">Circular reference detected — a child chain loops back to an entity already in its own ancestry</span>
              <span *ngIf="!hierarchyHasCircular">No circular references — the child-entity chain resolves cleanly</span>
            </div>
          </div>
          <div class="hierarchy-canvas">
            <ul class="org-tree">
              <li>
                <ng-container *ngTemplateOutlet="hierarchyNodeTpl; context: { node: hierarchyRoot, isRoot: true }"></ng-container>
              </li>
            </ul>
          </div>
        </div>

        <!-- Recursive tree-node template for the hierarchy panel -->
        <ng-template #hierarchyNodeTpl let-node="node" let-isRoot="isRoot">
          <div class="org-node" *ngIf="node">
            <div class="org-card" [class.org-card-root]="isRoot" [class.org-card-circular]="node.isCircular" [class.org-card-missing]="node.missing">
              <span class="org-card-icon">
                <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><rect x="1" y="1" width="11" height="11" rx="2" stroke="currentColor" stroke-width="1.2"/><path d="M4.5 7h5M7 4.5v5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg>
              </span>
              <div class="org-card-text">
                <span class="org-card-name">{{ node.entityName }}</span>
                <span class="org-card-link" *ngIf="!isRoot">via {{ node.linkAttribute }}</span>
              </div>
              <span class="org-card-badge org-card-badge-circular" *ngIf="node.isCircular" title="Circular reference — loops back to an ancestor">⚠ circular</span>
              <span class="org-card-badge org-card-badge-missing" *ngIf="node.missing" title="Referenced entity no longer exists">missing</span>
            </div>
            <ul class="org-tree" *ngIf="node.children?.length">
              <li *ngFor="let child of node.children">
                <ng-container *ngTemplateOutlet="hierarchyNodeTpl; context: { node: child, isRoot: false }"></ng-container>
              </li>
            </ul>
          </div>
        </ng-template>

        <ng-container *ngIf="!showJsonPanel && !showHierarchyPanel">

          <!-- ── PANEL 1: Entity Info ──────────────────────────────────────── -->
          <div class="config-panel">
            <div class="panel-header" (click)="togglePanel('info')">
              <div class="ph-left">
                <span class="ph-icon ph-icon-info">
                  <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><circle cx="6.5" cy="6.5" r="5.5" stroke="currentColor" stroke-width="1.2"/><path d="M6.5 6v3.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/><circle cx="6.5" cy="4" r="0.8" fill="currentColor"/></svg>
                </span>
                <span class="ph-title">ENTITY INFO</span>
              </div>
              <div class="ph-right">
                <span class="ph-summary">{{ selected.entity }} · {{ selected.entityType }}</span>
                <svg class="ph-chevron" [class.open]="panels['info']" width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M3 4.5l3 3 3-3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </div>
            </div>
            <div class="panel-body" *ngIf="panels['info']">
              <div class="form-grid form-grid-3">
                <div class="form-field">
                  <label>Entity Name</label>
                  <input type="text" [ngModel]="selected.entity" (ngModelChange)="selected.entity = $event; persist()" />
                </div>
                <div class="form-field">
                  <label>Display Name</label>
                  <input type="text" [ngModel]="selected.displayName" (ngModelChange)="selected.displayName = $event; persist()" />
                </div>
                <div class="form-field">
                  <label>Data Object Key</label>
                  <input type="text" [ngModel]="selected.dataObjectKey" (ngModelChange)="selected.dataObjectKey = $event; persist()" placeholder="e.g. customer_id" />
                </div>
                <div class="form-field">
                  <label>Category</label>
                  <input type="text" [ngModel]="selected.category" (ngModelChange)="selected.category = $event; persist()" placeholder="e.g. Customer Details" />
                </div>
                <div class="form-field">
                  <label>Primary Key</label>
                  <input type="text" [ngModel]="selected.primaryKey" (ngModelChange)="selected.primaryKey = $event; persist()" />
                </div>
                <div class="form-field">
                  <label>PK Type</label>
                  <select [ngModel]="selected.primaryKeyType" (ngModelChange)="selected.primaryKeyType = $event; persist()">
                    <option *ngFor="let t of PK_TYPES" [value]="t">{{ t }}</option>
                  </select>
                </div>
                <div class="form-field">
                  <label>Entity Type</label>
                  <select [ngModel]="selected.entityType" (ngModelChange)="selected.entityType = $event; persist()">
                    <option value="NonTimeSeries">NonTimeSeries</option>
                    <option value="timeSeries">timeSeries</option>
                  </select>
                </div>
                <div class="form-field">
                  <label>Description</label>
                  <textarea rows="1" [ngModel]="selected.description" (ngModelChange)="selected.description = $event; persist()" placeholder="Brief description of what this entity represents"></textarea>
                </div>
              </div>
              <div class="toggle-row">
                <div class="toggle-item">
                  <label>Business Entity</label>
                  <div class="toggle-switch" [class.on]="selected.isBusinessEntity" (click)="selected.isBusinessEntity = !selected.isBusinessEntity; persist()"><div class="toggle-knob"></div></div>
                </div>
                <div class="toggle-item">
                  <label>PK Auto-generated</label>
                  <div class="toggle-switch" [class.on]="selected.primaryKeyAutogenerated" (click)="selected.primaryKeyAutogenerated = !selected.primaryKeyAutogenerated; persist()"><div class="toggle-knob"></div></div>
                </div>
                <div class="toggle-item">
                  <label>Data Versioning</label>
                  <div class="toggle-switch" [class.on]="selected.dataVersionEnabled" (click)="selected.dataVersionEnabled = !selected.dataVersionEnabled; persist()"><div class="toggle-knob"></div></div>
                </div>
              </div>
              <div class="form-grid" *ngIf="selected.dataVersionEnabled" style="margin-top: 12px;">
                <div class="form-field">
                  <label>Versioning Type</label>
                  <select [ngModel]="selected.versioningType" (ngModelChange)="selected.versioningType = $event; persist()">
                    <option *ngFor="let v of VERSIONING_TYPES" [value]="v">{{ v }}</option>
                  </select>
                </div>
                <div class="form-field">
                  <label>Max Versions</label>
                  <input type="number" [ngModel]="selected.maxVersion" (ngModelChange)="selected.maxVersion = +$event; persist()" />
                </div>
              </div>
            </div>
          </div>

          <!-- ── PANEL 2: Attributes ──────────────────────────────────────── -->
          <div class="config-panel">
            <div class="panel-header" (click)="togglePanel('attrs')">
              <div class="ph-left">
                <span class="ph-icon ph-icon-attrs">
                  <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><rect x="1" y="1" width="11" height="11" rx="2" stroke="currentColor" stroke-width="1.2"/><path d="M4 4.5h5M4 6.5h5M4 8.5h3" stroke="currentColor" stroke-width="1" stroke-linecap="round"/></svg>
                </span>
                <span class="ph-title">ATTRIBUTES</span>
                <span class="panel-count">{{ selected.attributesList.length }}</span>
              </div>
              <div class="ph-right">
                <span class="ph-summary">{{ selected.attributesList.length }} attribute{{ selected.attributesList.length !== 1 ? 's' : '' }}</span>
                <svg class="ph-chevron" [class.open]="panels['attrs']" width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M3 4.5l3 3 3-3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </div>
            </div>
            <div class="panel-body panel-body-tight" *ngIf="panels['attrs']">

              <!-- Controls row -->
              <div class="attr-controls">
                <div class="attr-search-box">
                  <svg width="11" height="11" viewBox="0 0 11 11" fill="none"><circle cx="4.5" cy="4.5" r="3.5" stroke="currentColor" stroke-width="1.2"/><path d="M7.5 7.5L10 10" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg>
                  <input type="text" placeholder="Search attributes…" [(ngModel)]="attrSearch" />
                </div>
                <button class="btn-add-attr" (click)="openAddAttrModal()">
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M6 1v10M1 6h10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
                  Add Attribute
                </button>
              </div>

              <!-- Table header -->
              <div class="attr-table-head">
                <span class="atc-type">TYPE</span>
                <span class="atc-name">NAME</span>
                <span class="atc-disp">DISPLAY NAME</span>
                <span class="atc-flag">MANDATORY</span>
                <span class="atc-flag">UNIQUE</span>
                <span class="atc-flag">INDEXED</span>
                <span class="atc-flag">BUSINESS KEY</span>
                <span class="atc-flag">VERSIONED</span>
                <span class="atc-enabled">ENABLED</span>
                <span class="atc-actions"></span>
              </div>

              <!-- Attribute rows -->
              <div class="attr-table-body" cdkDropList (cdkDropListDropped)="dropAttr($event)">
                <div class="attr-row-wrap" *ngFor="let attr of filteredAttrs" cdkDrag>
                  <div *cdkDragPlaceholder class="attr-placeholder"></div>

                  <!-- Compact row -->
                  <div class="attr-row" [class.row-expanded]="editingAttr === attr" [class.row-disabled]="!attr.enableAttribute">
                    <div class="atc-type">
                      <div class="attr-drag" cdkDragHandle title="Drag to reorder">
                        <svg width="7" height="10" viewBox="0 0 7 10" fill="currentColor">
                          <circle cx="1.5" cy="1.5" r="1.5"/><circle cx="5.5" cy="1.5" r="1.5"/>
                          <circle cx="1.5" cy="5" r="1.5"/><circle cx="5.5" cy="5" r="1.5"/>
                          <circle cx="1.5" cy="8.5" r="1.5"/><circle cx="5.5" cy="8.5" r="1.5"/>
                        </svg>
                      </div>
                      <span class="type-pill" [ngClass]="'tp-' + attr.type">{{ attr.type }}</span>
                    </div>
                    <div class="atc-name">
                      <input type="text" class="attr-inline" [(ngModel)]="attr.name" (ngModelChange)="persist()" />
                    </div>
                    <div class="atc-disp">
                      <input type="text" class="attr-inline" [(ngModel)]="attr.displayName" (ngModelChange)="persist()" placeholder="—" />
                    </div>
                    <div class="atc-flag"><button class="flag-btn" [class.f-active]="attr.mandatory" (click)="attr.mandatory = !attr.mandatory; persist()">{{ attr.mandatory ? '✓' : '' }}</button></div>
                    <div class="atc-flag"><button class="flag-btn" [class.f-active]="attr.unique"    (click)="attr.unique = !attr.unique; persist()">{{ attr.unique ? '✓' : '' }}</button></div>
                    <div class="atc-flag"><button class="flag-btn" [class.f-active]="attr.indexed"   (click)="attr.indexed = !attr.indexed; persist()">{{ attr.indexed ? '✓' : '' }}</button></div>
                    <div class="atc-flag"><button class="flag-btn flag-bk" [class.f-active]="attr.businessKey" (click)="attr.businessKey = !attr.businessKey; persist()">{{ attr.businessKey ? '✓' : '' }}</button></div>
                    <div class="atc-flag"><button class="flag-btn" [class.f-active]="attr.versioned" (click)="attr.versioned = !attr.versioned; persist()">{{ attr.versioned ? '✓' : '' }}</button></div>
                    <div class="atc-enabled">
                      <div class="toggle-switch toggle-sm" [class.on]="attr.enableAttribute" (click)="attr.enableAttribute = !attr.enableAttribute; persist()">
                        <div class="toggle-knob"></div>
                      </div>
                    </div>
                    <div class="atc-actions">
                      <button class="btn-configure-attr" [class.active]="editingAttr === attr" (click)="openAttrModal(attr)" title="Configure">
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <circle cx="12" cy="12" r="3"/>
                          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
                        </svg>
                      </button>
                      <button class="btn-rm-attr" (click)="removeAttribute(attr.id)" title="Remove">×</button>
                    </div>
                  </div>

                </div><!-- /attr-row-wrap -->
              </div><!-- /attr-table-body -->
            </div>
          </div>

          <!-- ── PANEL 3: DEAM Reads ───────────────────────────────────────── -->
          <div class="config-panel">
            <div class="panel-header" (click)="togglePanel('reads')">
              <div class="ph-left">
                <span class="ph-icon ph-icon-reads">
                  <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><rect x="1" y="3" width="11" height="7" rx="1.5" stroke="currentColor" stroke-width="1.2"/><path d="M3.5 6.5h2M7 6.5h2.5" stroke="currentColor" stroke-width="1" stroke-linecap="round"/></svg>
                </span>
                <span class="ph-title">DEAM READS</span>
                <span class="panel-count">{{ selected.deamReads.length }}</span>
              </div>
              <div class="ph-right">
                <span class="ph-summary">{{ selected.deamReads.length }} read{{ selected.deamReads.length !== 1 ? 's' : '' }}</span>
                <svg class="ph-chevron" [class.open]="panels['reads']" width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M3 4.5l3 3 3-3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </div>
            </div>
            <div class="panel-body" *ngIf="panels['reads']">

              <div class="filter-list">
                <div class="filter-item" *ngFor="let r of selected.deamReads">
                  <div class="filter-hdr" (click)="toggleReadExpand(r.id)">
                    <div class="filter-left">
                      <span class="filter-type-pill" [class.ft-dynamic]="r.filters.length" [class.ft-static]="!r.filters.length">{{ r.filters.length ? 'dynamic' : 'static' }}</span>
                      <input type="text" class="filter-name-input" [(ngModel)]="r.name" (ngModelChange)="persist()" (click)="$event.stopPropagation()" placeholder="filterName" />
                    </div>
                    <div class="filter-right">
                      <svg class="ph-chevron sm" [class.open]="expandedReadId === r.id" width="11" height="11" viewBox="0 0 11 11" fill="none"><path d="M2 4l3.5 3.5L9 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                      <button class="btn-remove-row" (click)="removeRead(r.id); $event.stopPropagation()">✕</button>
                    </div>
                  </div>
                  <div class="filter-body" *ngIf="expandedReadId === r.id">
                    <div class="sub-section trigger-cond-section">
                      <div class="entity-selector-row">
                        <span class="entity-label">Entity:</span>
                        <span class="entity-fixed">{{ r.entityName }}</span>
                      </div>

                      <div class="trigger-list">
                        <ng-container *ngFor="let f of r.filters; let fi = index">
                          <div class="logic-chain-row" *ngIf="fi > 0">
                            <div class="logic-chain-line"></div>
                            <div class="logic-toggle">
                              <button class="logic-btn" [class.active]="(f.logicalOperator || 'AND') === 'AND'" (click)="updateDynFilterLogic(f, 'AND')">AND</button>
                              <button class="logic-btn" [class.active]="f.logicalOperator === 'OR'" (click)="updateDynFilterLogic(f, 'OR')">OR</button>
                            </div>
                          </div>
                          <div class="trigger-row">
                            <select class="trigger-field" [(ngModel)]="f.attributeName" (ngModelChange)="persist()">
                              <option *ngFor="let a of childEntityAttributes(r.entityName)" [value]="a">{{ a }}</option>
                            </select>
                            <select class="trigger-op" [(ngModel)]="f.operator" (ngModelChange)="persist()">
                              <option *ngFor="let op of TRIGGER_OPERATORS" [value]="op">{{ op }}</option>
                            </select>
                            <ng-container *ngIf="f.operator !== 'between'">
                              <input class="trigger-val" type="text" [(ngModel)]="f.value" (ngModelChange)="persist()" [placeholder]="'@' + f.attributeName + '@'" />
                            </ng-container>
                            <ng-container *ngIf="f.operator === 'between'">
                              <input class="trigger-val between-input" type="text" [(ngModel)]="f.value" (ngModelChange)="persist()" placeholder="Min" />
                              <span class="between-text">TO</span>
                              <input class="trigger-val between-input" type="text" [(ngModel)]="f.value2" (ngModelChange)="persist()" placeholder="Max" />
                            </ng-container>
                            <input class="trigger-scope" type="text" [(ngModel)]="f.scope" (ngModelChange)="persist()" placeholder="scope" title="Scope" />
                            <button class="item-remove small" (click)="removeDynFilter(r, f.id)">✕</button>
                          </div>
                        </ng-container>
                        <div class="trigger-empty" *ngIf="!r.filters.length">No conditions defined — this read will export as a plain static SELECT.</div>
                      </div>

                      <button class="add-inline-btn" (click)="addDynFilter(r)">+ Add condition</button>
                    </div>
                  </div>
                </div>
                <div class="filter-empty" *ngIf="!selected.deamReads.length">No DEAM reads defined yet</div>
              </div>
              <div class="add-filter-row">
                <input type="text" placeholder="filter name * (e.g. excelfilter)" [(ngModel)]="newRead.name" (keydown.enter)="addRead()" />
                <button class="btn-add-row" (click)="addRead()" [disabled]="!newRead.name.trim()">+ Add DEAM Read</button>
              </div>

            </div>
          </div>

          <!-- ── PANEL 4: Business Rules ────────────────────────────────────── -->
          <div class="config-panel">
            <div class="panel-header" (click)="togglePanel('rules')">
              <div class="ph-left">
                <span class="ph-icon ph-icon-rules">
                  <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><path d="M2 4h9M2 6.5h6M2 9h4" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/><circle cx="10" cy="9" r="2" stroke="currentColor" stroke-width="1.2"/></svg>
                </span>
                <span class="ph-title">BUSINESS RULES</span>
              </div>
              <div class="ph-right">
                <span class="ph-summary">{{ selected.businessRules.intraEntityRules.length + selected.businessRules.interEntityRules.length + selected.businessRules.globalEntityRules.length }} rules</span>
                <svg class="ph-chevron" [class.open]="panels['rules']" width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M3 4.5l3 3 3-3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </div>
            </div>
            <div class="panel-body" *ngIf="panels['rules']">
              <div class="rule-toggles">
                <div class="rule-tog">
                  <div class="toggle-switch toggle-sm" [class.on]="selected.businessRules.intraEntityRulesEnabled"
                       (click)="selected.businessRules.intraEntityRulesEnabled = !selected.businessRules.intraEntityRulesEnabled; persist()"><div class="toggle-knob"></div></div>
                  <span>Intra-Entity Rules</span>
                </div>
                <div class="rule-tog">
                  <div class="toggle-switch toggle-sm" [class.on]="selected.businessRules.interEntityRulesEnabled"
                       (click)="selected.businessRules.interEntityRulesEnabled = !selected.businessRules.interEntityRulesEnabled; persist()"><div class="toggle-knob"></div></div>
                  <span>Inter-Entity Rules</span>
                </div>
                <div class="rule-tog">
                  <div class="toggle-switch toggle-sm" [class.on]="selected.businessRules.globalEntityRulesEnabled"
                       (click)="selected.businessRules.globalEntityRulesEnabled = !selected.businessRules.globalEntityRulesEnabled; persist()"><div class="toggle-knob"></div></div>
                  <span>Global Rules</span>
                </div>
              </div>

              <ng-container *ngTemplateOutlet="ruleSection; context: { title: 'Intra-Entity Rules', scope: 'intra', rules: selected.businessRules.intraEntityRules }"></ng-container>
              <ng-container *ngTemplateOutlet="ruleSection; context: { title: 'Inter-Entity Rules', scope: 'inter', rules: selected.businessRules.interEntityRules }"></ng-container>
              <ng-container *ngTemplateOutlet="ruleSection; context: { title: 'Global Rules', scope: 'global', rules: selected.businessRules.globalEntityRules }"></ng-container>

              <!-- Operation -->
              <div class="attr-section-divider"></div>
              <div class="sub-section">
                <div class="sub-section-header"><span>Operation</span></div>
                <div class="form-field operation-field">
                  <select [ngModel]="selected.businessRules.operation" (ngModelChange)="selected.businessRules.operation = $event; persist()">
                    <option value="">— none —</option>
                    <option value="ACCEPT">ACCEPT</option>
                    <option value="REJECT">REJECT</option>
                  </select>
                </div>
              </div>

              <!-- Transformation -->
              <div class="sub-section">
                <div class="sub-section-header"><span>Transformation</span><span class="sub-count">{{ transformationKeys(selected).length }}</span></div>
                <div class="kv-table" *ngIf="transformationKeys(selected).length">
                  <div class="kv-row kv-head kv-row-transform"><span>Attribute</span><span>Assign From</span><span>Value / Source Attribute</span><span></span></div>
                  <div class="kv-row kv-row-transform" *ngFor="let key of transformationKeys(selected)">
                    <span class="transform-attr-name">{{ key }}</span>
                    <select [(ngModel)]="selected.businessRules.transformation[key].assignedValueType" (ngModelChange)="persist()">
                      <option *ngFor="let t of TRANSFORM_VALUE_TYPES" [value]="t">{{ t }}</option>
                    </select>
                    <input type="text" [(ngModel)]="selected.businessRules.transformation[key].value" (ngModelChange)="persist()"
                           [placeholder]="selected.businessRules.transformation[key].assignedValueType === 'attribute' ? 'source attribute name' : 'literal value'" />
                    <button class="btn-remove-row" (click)="removeTransformation(key)">✕</button>
                  </div>
                </div>
                <div class="rule-empty" *ngIf="!transformationKeys(selected).length">No transformations defined</div>
                <div class="add-row-inline">
                  <select [(ngModel)]="newTransformAttr">
                    <option value="">select attribute…</option>
                    <option *ngFor="let a of selected.attributesList" [value]="a.name">{{ a.name }}</option>
                  </select>
                  <button class="btn-add-row" (click)="addTransformation()" [disabled]="!newTransformAttr">+ Add</button>
                </div>
              </div>
            </div>
          </div>

          <!-- Shared rule-list template (used for Intra/Inter/Global) -->
          <ng-template #ruleSection let-title="title" let-scope="scope" let-rules="rules">
            <div class="sub-section">
              <div class="sub-section-header"><span>{{ title }}</span><span class="sub-count">{{ rules.length }}</span></div>
              <div class="rule-table" *ngIf="rules.length">
                <div class="rule-row rule-head"><span>Attribute</span><span>Operator</span><span>Value</span><span>Logic</span><span></span></div>
                <div class="rule-row" *ngFor="let r of rules">
                  <input type="text" [(ngModel)]="r.attributeName" (ngModelChange)="persist()" placeholder="attr" />
                  <select [(ngModel)]="r.filterOperator" (ngModelChange)="persist()">
                    <option *ngFor="let op of STATUS_OPERATORS" [value]="op">{{ op }}</option>
                  </select>
                  <input type="text" [(ngModel)]="r.filterValue" (ngModelChange)="persist()" placeholder="value" />
                  <select [(ngModel)]="r.logicalOperator" (ngModelChange)="persist()">
                    <option value="">—</option>
                    <option value="AND">AND</option>
                    <option value="OR">OR</option>
                  </select>
                  <button class="btn-remove-row" (click)="removeRule(scope, r.id)">✕</button>
                </div>
              </div>
              <div class="rule-empty" *ngIf="!rules.length">No rules defined</div>
              <div class="add-row-rule">
                <input type="text" placeholder="attributeName" [ngModel]="newRuleMap[scope].attributeName" (ngModelChange)="newRuleMap[scope].attributeName = $event" />
                <select [ngModel]="newRuleMap[scope].filterOperator" (ngModelChange)="newRuleMap[scope].filterOperator = $event">
                  <option *ngFor="let op of STATUS_OPERATORS" [value]="op">{{ op }}</option>
                </select>
                <input type="text" placeholder="value" [ngModel]="newRuleMap[scope].filterValue" (ngModelChange)="newRuleMap[scope].filterValue = $event" />
                <select [ngModel]="newRuleMap[scope].logicalOperator" (ngModelChange)="newRuleMap[scope].logicalOperator = $event">
                  <option value="AND">AND</option>
                  <option value="OR">OR</option>
                </select>
                <button class="btn-add-row" (click)="addRule(scope)">+ Add Rule</button>
              </div>
            </div>
          </ng-template>

          <!-- ── PANEL 5: Child Entities ────────────────────────────────────── -->
          <div class="config-panel config-panel-last">
            <div class="panel-header" (click)="togglePanel('children')">
              <div class="ph-left">
                <span class="ph-icon ph-icon-children">
                  <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><circle cx="6.5" cy="2.5" r="1.5" stroke="currentColor" stroke-width="1.2"/><circle cx="2.5" cy="10.5" r="1.5" stroke="currentColor" stroke-width="1.2"/><circle cx="10.5" cy="10.5" r="1.5" stroke="currentColor" stroke-width="1.2"/><path d="M6.5 4v2M5 6.5L2.5 9M8 6.5L10.5 9" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg>
                </span>
                <span class="ph-title">CHILD ENTITIES</span>
                <span class="panel-count">{{ selected.childEntities.length }}</span>
              </div>
              <div class="ph-right">
                <span class="ph-summary">{{ childEntitySummary(selected) || 'none' }}</span>
                <svg class="ph-chevron" [class.open]="panels['children']" width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M3 4.5l3 3 3-3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </div>
            </div>
            <div class="panel-body" *ngIf="panels['children']">
              <div class="child-link-list">
                <div class="child-link-card" *ngFor="let c of selected.childEntities">
                  <div class="clc-icon">
                    <svg width="14" height="14" viewBox="0 0 13 13" fill="none"><rect x="1" y="1" width="8" height="8" rx="1.5" stroke="currentColor" stroke-width="1.1"/></svg>
                  </div>
                  <div class="clc-body">
                    <span class="clc-name">{{ c.entityName }}</span>
                    <span class="clc-link">linked via <strong>{{ c.linkAttribute }}</strong></span>
                  </div>
                  <button class="child-rm" (click)="removeChildEntity(c.id)">×</button>
                </div>
                <span class="children-empty" *ngIf="!selected.childEntities.length">No child entities linked</span>
              </div>
              <div class="add-row-child">
                <select [(ngModel)]="newChildEntityLink.entityName" (ngModelChange)="newChildEntityLink.linkAttribute = ''">
                  <option value="">select child entity…</option>
                  <option *ngFor="let n of childEntityOptions(selected.entity)" [value]="n">{{ n }}</option>
                </select>
                <select [(ngModel)]="newChildEntityLink.linkAttribute" [disabled]="!newChildEntityLink.entityName">
                  <option value="">linking attribute…</option>
                  <option *ngFor="let a of childEntityAttributes(newChildEntityLink.entityName)" [value]="a">{{ a }}</option>
                </select>
                <button class="btn-add-row" (click)="addChildEntity()" [disabled]="!newChildEntityLink.entityName || !newChildEntityLink.linkAttribute">+ Link Child</button>
              </div>
            </div>
          </div>



        </ng-container><!-- /form panels -->
      </ng-container>

      <ng-template #emptyState>
        <div class="empty-state">
          <div class="empty-state-icon">
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="22" height="22" rx="4"/><path d="M9 14h10M14 9v10" stroke-linecap="round"/></svg>
          </div>
          <p>Hover over an entity on the left<br/>to configure its DEAM definition.</p>
        </div>
      </ng-template>

    </div><!-- /main-area -->

  <!-- ── Add entity modal ─────────────────────────────────────────────────── -->
  <div class="modal-overlay" *ngIf="showAddModal" (click)="closeAddModal($event)">
    <div class="modal-box">
      <div class="modal-header">
        <h3>New Entity</h3>
        <button class="modal-close" (click)="showAddModal = false">✕</button>
      </div>
      <div class="modal-body">
        <div class="form-field mb12">
          <label>Entity Name *</label>
          <input type="text" [(ngModel)]="newEnt.entity" placeholder="e.g. product_master" />
        </div>
        <div class="form-field mb12">
          <label>Display Name</label>
          <input type="text" [(ngModel)]="newEnt.displayName" placeholder="e.g. Product Master" />
        </div>
        <div class="form-grid mb12">
          <div class="form-field">
            <label>Entity Type</label>
            <select [(ngModel)]="newEnt.entityType">
              <option value="NonTimeSeries">NonTimeSeries</option>
              <option value="timeSeries">timeSeries</option>
            </select>
          </div>
        </div>
        <div class="toggle-row">
          <div class="toggle-item">
            <label>Business Entity</label>
            <div class="toggle-switch" [class.on]="newEnt.isBusinessEntity" (click)="newEnt.isBusinessEntity = !newEnt.isBusinessEntity"><div class="toggle-knob"></div></div>
          </div>
          <div class="toggle-item">
            <label>Data Versioning</label>
            <div class="toggle-switch" [class.on]="newEnt.dataVersionEnabled" (click)="newEnt.dataVersionEnabled = !newEnt.dataVersionEnabled"><div class="toggle-knob"></div></div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn-cancel" (click)="showAddModal = false">Cancel</button>
        <button class="btn-confirm" (click)="confirmAddEntity()" [disabled]="!newEnt.entity.trim()">Create Entity</button>
      </div>
    </div>
  </div>

  <!-- ── Add attribute modal (full configuration, same as Configure Attribute) ── -->
  <div class="modal-overlay" *ngIf="draftAttr as attr" (click)="closeAddAttrModal()">
    <div class="modal-box modal-box-lg" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>New Attribute</h3>
        <button class="modal-close" (click)="closeAddAttrModal()">✕</button>
      </div>
      <div class="modal-body modal-body-scroll">
        <ng-container *ngTemplateOutlet="attrConfigFields; context: { attr: attr, showName: true }"></ng-container>
      </div>
      <div class="modal-footer">
        <button class="btn-cancel" (click)="closeAddAttrModal()">Cancel</button>
        <button class="btn-confirm" (click)="addAttribute()" [disabled]="!attr.name.trim()">Add Attribute</button>
      </div>
    </div>
  </div>

  <!-- ── Attribute config modal ────────────────────────────────────────────── -->
  <div class="modal-overlay" *ngIf="editingAttr as attr" (click)="closeAttrModal()">
    <div class="modal-box modal-box-lg" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>Configure Attribute — <span class="modal-attr-name">{{ attr.name }}</span></h3>
        <button class="modal-close" (click)="closeAttrModal()">✕</button>
      </div>
      <div class="modal-body modal-body-scroll">
        <ng-container *ngTemplateOutlet="attrConfigFields; context: { attr: attr, showName: false }"></ng-container>
      </div>
      <div class="modal-footer">
        <button class="btn-confirm" (click)="closeAttrModal()">Done</button>
      </div>
    </div>
  </div>

  <!-- ── Shared attribute-configuration fields (used by both New Attribute & Configure Attribute modals) ── -->
  <ng-template #attrConfigFields let-attr="attr" let-showName="showName">

    <div class="attr-detail-grid">
      <!-- Name / Display name (creation only) -->
      <div class="form-field" *ngIf="showName">
        <label>Attribute Name *</label>
        <input type="text" [(ngModel)]="attr.name" placeholder="e.g. customer_id" />
      </div>
      <div class="form-field" *ngIf="showName">
        <label>Display Name</label>
        <input type="text" [(ngModel)]="attr.displayName" placeholder="e.g. Customer ID" />
      </div>
      <!-- Type select -->
      <div class="form-field">
        <label>Type</label>
        <select [(ngModel)]="attr.type" (ngModelChange)="persist()">
          <option *ngFor="let t of ATTR_TYPES" [value]="t">{{ t }}</option>
        </select>
      </div>
      <!-- Sub-type (array only) -->
      <div class="form-field" *ngIf="attr.type === 'array'">
        <label>Sub-Type</label>
        <select [(ngModel)]="attr.subType" (ngModelChange)="persist()">
          <option value="">— none —</option>
          <option *ngFor="let t of SUB_TYPES" [value]="t">{{ t }}</option>
        </select>
      </div>
      <!-- Max length -->
      <div class="form-field" *ngIf="attr.type === 'string' || attr.type === 'integer' || attr.type === 'long' || attr.type === 'array'">
        <label>Max Length</label>
        <input type="number" [(ngModel)]="attr.maxLength" (ngModelChange)="persist()" />
      </div>
      <!-- Numeric precision/scale -->
      <div class="form-field" *ngIf="attr.type === 'numeric'">
        <label>Precision</label>
        <input type="number" [(ngModel)]="attr.precision" (ngModelChange)="persist()" />
      </div>
      <div class="form-field" *ngIf="attr.type === 'numeric'">
        <label>Scale</label>
        <input type="number" [(ngModel)]="attr.scale" (ngModelChange)="persist()" />
      </div>
      <!-- Date format -->
      <div class="form-field" *ngIf="attr.type === 'datetime'">
        <label>Date Format</label>
        <input type="text" [(ngModel)]="attr.dateformat" (ngModelChange)="persist()" placeholder="yyyy-MM-dd" />
      </div>
      <!-- Static string -->
      <div class="form-field" *ngIf="attr.type === 'string'">
        <label>Static String</label>
        <input type="text" [(ngModel)]="attr.staticString" (ngModelChange)="persist()" placeholder="default value" />
      </div>
      <!-- FK references -->
      <div class="form-field">
        <label>Referenced Entity</label>
        <select [ngModel]="attr.referencedEntity" (ngModelChange)="onReferencedEntityChange(attr, $event)">
          <option [ngValue]="null">— none —</option>
          <option *ngFor="let e of referencableEntities" [value]="e">{{ e }}</option>
        </select>
      </div>
      <div class="form-field">
        <label>Referenced Attribute</label>
        <select [(ngModel)]="attr.referencedAttribute" (ngModelChange)="persist()" [disabled]="!attr.referencedEntity">
          <option [ngValue]="null">— none —</option>
          <option *ngFor="let a of referencableAttributes(attr.referencedEntity)" [value]="a">{{ a }}</option>
        </select>
      </div>
    </div>

    <!-- Boolean toggles row -->
    <div class="attr-toggle-row">
      <div class="attr-tog">
        <span>Auto-Generated</span>
        <div class="toggle-switch toggle-sm" [class.on]="attr.autoGenerated" (click)="attr.autoGenerated = !attr.autoGenerated; persist()"><div class="toggle-knob"></div></div>
      </div>
      <div class="attr-tog">
        <span>Allow Null</span>
        <div class="toggle-switch toggle-sm" [class.on]="attr.allowNull" (click)="attr.allowNull = !attr.allowNull; persist()"><div class="toggle-knob"></div></div>
      </div>
      <div class="attr-tog">
        <span>Enable Update</span>
        <div class="toggle-switch toggle-sm" [class.on]="attr.enableUpdate" (click)="attr.enableUpdate = !attr.enableUpdate; persist()"><div class="toggle-knob"></div></div>
      </div>
    </div>

    <!-- Valid values -->
    <div class="attr-vv-section">
      <label>Valid Values</label>
      <div class="vv-chips">
        <span class="vv-chip" *ngFor="let v of attr.validValues; let vi = index">
          {{ v }}<button class="vv-rm" (click)="removeValidValue(attr, vi)">×</button>
        </span>
        <span class="vv-empty" *ngIf="!attr.validValues.length">No valid values defined</span>
      </div>
      <div class="add-row-inline">
        <input type="text" placeholder="add value…"
               [ngModel]="newValidValueMap[attr.id] || ''"
               (ngModelChange)="newValidValueMap[attr.id] = $event"
               (keydown.enter)="addValidValue(attr)" />
        <button class="btn-add-row" (click)="addValidValue(attr)">+ Add</button>
      </div>
    </div>

    <!-- Status validation (state machine) -->
    <div class="attr-section-divider"></div>
    <div class="status-mgmt-section">
      <div class="status-mgmt-header">
        <div class="status-mgmt-title">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>
          <span>Status Validation</span>
        </div>
        <div class="toggle-switch toggle-sm" [class.on]="!!attr.statusManagement" (click)="toggleStatusValidation(attr)">
          <div class="toggle-knob"></div>
        </div>
      </div>

      <div class="status-states" *ngIf="attr.statusManagement">
        <div class="status-state-card" *ngFor="let stateName of stateNames(attr)">
          <div class="ssc-header">
            <input type="text" class="ssc-name-input"
                   [ngModel]="stateName"
                   (ngModelChange)="renameState(attr, stateName, $event)"
                   placeholder="STATE_NAME" />
            <button class="btn-rm-state" (click)="removeState(attr, stateName)" title="Remove state">×</button>
          </div>
          <div class="ssc-grid">
            <div class="form-field">
              <label>Target Attribute</label>
              <select [(ngModel)]="attr.statusManagement.statusValidation[stateName].targetAttribute" (ngModelChange)="persist()">
                <option value="">— none —</option>
                <option *ngFor="let a of selected?.attributesList" [value]="a.name">{{ a.name }}</option>
              </select>
            </div>
            <div class="form-field">
              <label>Workflow</label>
              <input type="text" [(ngModel)]="attr.statusManagement.statusValidation[stateName].workflow" (ngModelChange)="persist()" placeholder="e.g. aw_pricing_approval_all" />
            </div>
            <div class="form-field">
              <label>Next Status</label>
              <input type="text" [attr.list]="'state-suggest-' + attr.id" [(ngModel)]="attr.statusManagement.statusValidation[stateName].nextStatus" (ngModelChange)="persist()" placeholder="e.g. PUBLISHED" />
            </div>
            <div class="form-field">
              <label>On Fail</label>
              <input type="text" [attr.list]="'state-suggest-' + attr.id" [(ngModel)]="attr.statusManagement.statusValidation[stateName].onFail" (ngModelChange)="persist()" placeholder="e.g. REJECTED" />
            </div>
          </div>

          <div class="ssc-rules">
            <div class="ssc-rules-head">
              <label>Validation Rules</label>
              <button class="btn-add-row" (click)="addValidationRule(attr, stateName)">+ Add Rule</button>
            </div>
            <div class="ssc-rule-row" *ngFor="let rule of attr.statusManagement.statusValidation[stateName].validation">
              <select [(ngModel)]="rule.attributeName" (ngModelChange)="persist()">
                <option value="">attribute…</option>
                <option *ngFor="let a of selected?.attributesList" [value]="a.name">{{ a.name }}</option>
              </select>
              <select [(ngModel)]="rule.operator" (ngModelChange)="persist()">
                <option *ngFor="let op of STATUS_OPERATORS" [value]="op">{{ op }}</option>
              </select>
              <input type="text" placeholder="value" [(ngModel)]="rule.value" (ngModelChange)="persist()" />
              <select [(ngModel)]="rule.logicalOperator" (ngModelChange)="persist()">
                <option value="">—</option>
                <option value="AND">AND</option>
                <option value="OR">OR</option>
              </select>
              <button class="btn-rm-attr" (click)="removeValidationRule(attr, stateName, rule.id)" title="Remove">×</button>
            </div>
            <div class="ssc-rules-empty" *ngIf="!attr.statusManagement.statusValidation[stateName].validation.length">No validation rules</div>
          </div>
        </div>

        <datalist [id]="'state-suggest-' + attr.id">
          <option *ngFor="let s of stateNames(attr)" [value]="s"></option>
        </datalist>

        <button class="btn-add-state" (click)="addState(attr)">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M6 1v10M1 6h10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
          Add State
        </button>
      </div>
    </div>

  </ng-template>

  <!-- ── Toast ─────────────────────────────────────────────────────────────── -->


